/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ChevronDownIcon, ChevronUpIcon } from 'tdesign-icons-react';
import { PopupRef, Tooltip } from 'tdesign-react';

import { WarningStatus } from '@/components/icon';
import { AuditStatusType } from '@/const/status';
import { getBotAuditMessage } from '@/services/bot';

import { getAuditStatusIconMap } from '../../ugcList/cards/card/operations';
import styles from './style/index.module.less';

interface IBotStatus {
  id?: string;
  status: AuditStatusType;
}

const BotStatus: React.FC<IBotStatus> = (props) => {
  const { id, status } = props;

  const tooltipRef = useRef<Partial<PopupRef>>(null);

  const [list, setList] = useState<string[]>([]);
  const [showMore, setShowMore] = useState(false);

  const [searchParams] = useSearchParams();
  const release = searchParams.get('release') === 'true';
  const AUDIT_STATUS_ICON_MAP = getAuditStatusIconMap(release);

  const iconColor = useMemo(
    () => (getAuditStatusIconMap(release)[status]),
    [AUDIT_STATUS_ICON_MAP, release],
  );

  const handleClick1 = useCallback(() => {
    setShowMore(true);
  }, []);

  const ToolTipContent = useMemo(() => () => (
    <div className={styles.tooltip}>
      <div className={styles.title}><WarningStatus />
        <div className={styles.text}>角色审核意见</div>
      </div>
      <div className={styles.content}>
        {
          (showMore ? list : list.slice(0, 3)).map((e, i) => (
            <div key={`${e}/${i}`} className={styles.msg}>{i + 1}. {e}</div>
          ))
        }
        {list.length > 3 && <div className={styles.more} onClick={handleClick1}>
          {showMore ? <><ChevronUpIcon size={16} />收起</>
            : <><ChevronDownIcon size={16} />查看全部</>}
        </div>}
      </div>
    </div>
  ), [list, showMore, handleClick1]);

  useEffect(() => {
    if (status === AuditStatusType.STATUS_TYPE_MANUAL_FAIL && id) {
      getBotAuditMessage(id).then((res) => {
        setList(res);
        if (res.length > 0) {
          tooltipRef.current?.setVisible?.(true);
        }
      });
    }
    return () => {
      setList([]);
    };
  }, [status, id]);

  return <>
    <div className='attach'></div>
    <Tooltip
      ref={tooltipRef}
      content={ToolTipContent()}
      destroyOnClose={false}
      showArrow
      attach={'.attach'}
      placement='bottom-right'
      theme="default"
      trigger='click'
      disabled={status !== AuditStatusType.STATUS_TYPE_MANUAL_FAIL}
      triggerElement={
        <div className={styles.status}
          style={{ background: iconColor?.color }}>
          {iconColor?.icon}
          <div>{iconColor?.label}</div>
        </div>
      }
    >
    </Tooltip ></>;
};

export default (BotStatus);
